/* Native pot-carousel controls. The row, touch scrolling and loader keep their owners. */
(function () {
  'use strict';

  if (window.FlorafyPdpPotScroll) {
    window.FlorafyPdpPotScroll.bind();
    return;
  }

  var current = null;

  function destroy() {
    if (!current) return;
    current.destroy();
    current = null;
  }

  function bind() {
    var slider = document.querySelector('.js-oppot-slider');
    var track = document.querySelector('.scroll-progress-track');
    var thumb = document.querySelector('.scroll-progress-thumb');
    if (!slider || !track || !thumb) {
      destroy();
      return;
    }
    if (current && current.slider === slider && current.track === track) return;
    destroy();

    var controls = document.querySelector('.pdp-pot-controls');
    var previous = document.querySelector('[data-pdp-pot-previous]');
    var next = document.querySelector('[data-pdp-pot-next]');
    var clientWidth = 0;
    var scrollWidth = 0;
    var trackVisible = null;
    var frame = null;
    var measureBeforePaint = false;
    var resizeObserver = null;
    var mutationObserver = null;
    var pointer = null;
    var destroyed = false;

    function setTrackVisible(visible) {
      if (trackVisible === visible) return;
      trackVisible = visible;
      track.style.display = visible ? '' : 'none';
      if (controls) controls.hidden = !visible;
    }

    function paint() {
      if (destroyed) return;
      var maxScroll = scrollWidth - clientWidth;
      if (maxScroll <= 0) {
        setTrackVisible(false);
        track.setAttribute('aria-valuenow', '0');
        if (previous) previous.disabled = true;
        if (next) next.disabled = true;
        return;
      }
      var left = Math.max(0, Math.min(maxScroll, slider.scrollLeft));
      var scrollPercent = left / maxScroll;
      var shared = window.florafySliderControls;
      var progress = shared && shared.progress ? shared.progress(left, scrollWidth, clientWidth) : null;
      var thumbWidth = progress ? progress.width : Math.max(20, (clientWidth / scrollWidth) * 100);
      setTrackVisible(true);
      thumb.style.width = thumbWidth + '%';
      thumb.style.left = (progress ? progress.left : scrollPercent * (100 - thumbWidth)) + '%';
      track.setAttribute('aria-valuenow', String(Math.round(scrollPercent * 100)));
      if (previous) previous.disabled = left <= 1;
      if (next) next.disabled = left >= maxScroll - 1;
    }

    function measure() {
      if (destroyed) return;
      clientWidth = slider.clientWidth;
      scrollWidth = slider.scrollWidth;
      paint();
    }

    function schedulePaint(needsMeasurement) {
      measureBeforePaint = measureBeforePaint || needsMeasurement;
      if (frame !== null) return;
      frame = requestAnimationFrame(function () {
        frame = null;
        if (destroyed) return;
        if (measureBeforePaint) {
          measureBeforePaint = false;
          measure();
        } else {
          paint();
        }
      });
    }

    function onScroll() { schedulePaint(false); }
    function onMutation() { schedulePaint(true); }

    function moveTo(left, smooth) {
      var maxScroll = Math.max(0, scrollWidth - clientWidth);
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      slider.scrollTo({ left: Math.max(0, Math.min(maxScroll, left)), behavior: smooth && !reduced ? 'smooth' : 'instant' });
      schedulePaint(false);
    }

    function step(direction) { moveTo(slider.scrollLeft + direction * clientWidth * 0.8, true); }
    function onPrevious() { step(-1); }
    function onNext() { step(1); }

    function onKeyDown(event) {
      if (event.key === 'Home') moveTo(0, true);
      else if (event.key === 'End') moveTo(scrollWidth - clientWidth, true);
      else if (event.key === 'ArrowLeft') step(-1);
      else if (event.key === 'ArrowRight') step(1);
      else return;
      event.preventDefault();
    }

    function scrub(event) {
      var bounds = track.getBoundingClientRect();
      if (bounds.width <= 0) return;
      moveTo((event.clientX - bounds.left) / bounds.width * (scrollWidth - clientWidth), false);
    }

    function onPointerDown(event) {
      if (event.button !== undefined && event.button !== 0) return;
      pointer = event.pointerId;
      if (track.setPointerCapture) track.setPointerCapture(pointer);
      track.focus({ preventScroll: true });
      event.preventDefault();
      scrub(event);
    }

    function onPointerMove(event) {
      if (pointer !== null && event.pointerId === pointer) scrub(event);
    }

    function endPointer(event) {
      if (event.pointerId !== pointer) return;
      var id = pointer;
      pointer = null;
      if (track.hasPointerCapture && track.hasPointerCapture(id)) track.releasePointerCapture(id);
    }

    slider.addEventListener('scroll', onScroll, { passive: true });
    if (previous) previous.addEventListener('click', onPrevious);
    if (next) next.addEventListener('click', onNext);
    track.addEventListener('keydown', onKeyDown);
    track.addEventListener('pointerdown', onPointerDown);
    track.addEventListener('pointermove', onPointerMove);
    track.addEventListener('pointerup', endPointer);
    track.addEventListener('pointercancel', endPointer);
    track.addEventListener('lostpointercapture', endPointer);

    if (typeof MutationObserver !== 'undefined') {
      mutationObserver = new MutationObserver(onMutation);
      mutationObserver.observe(slider, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'style', 'class'] });
    }
    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(measure);
      resizeObserver.observe(slider);
    } else {
      window.addEventListener('load', measure, { once: true });
      window.addEventListener('resize', measure);
      schedulePaint(true);
    }

    current = {
      slider: slider,
      track: track,
      destroy: function () {
        destroyed = true;
        slider.removeEventListener('scroll', onScroll);
        if (previous) previous.removeEventListener('click', onPrevious);
        if (next) next.removeEventListener('click', onNext);
        track.removeEventListener('keydown', onKeyDown);
        track.removeEventListener('pointerdown', onPointerDown);
        track.removeEventListener('pointermove', onPointerMove);
        track.removeEventListener('pointerup', endPointer);
        track.removeEventListener('pointercancel', endPointer);
        track.removeEventListener('lostpointercapture', endPointer);
        if (pointer !== null && track.hasPointerCapture && track.hasPointerCapture(pointer)) track.releasePointerCapture(pointer);
        pointer = null;
        if (frame !== null) window.cancelAnimationFrame(frame);
        if (resizeObserver) resizeObserver.disconnect();
        if (mutationObserver) mutationObserver.disconnect();
        window.removeEventListener('load', measure);
        window.removeEventListener('resize', measure);
      },
    };
  }

  window.FlorafyPdpPotScroll = { bind: bind, destroy: destroy };
  if (document.readyState === 'complete' || document.readyState === 'interactive') bind();
  else document.addEventListener('DOMContentLoaded', bind, { once: true });
  window.addEventListener('combined-listing:swapped', bind);
})();
